import { PencilBrush } from "fabric";
import Tool, { type ITool } from "./Tool";
import CanvasUtils from "../utils/CanvasUtils";

export type BrushColors = typeof BRUSH_COLORS;

export type BrushColor = BrushColors[number];

export interface BrushOptions {
  color: BrushColor;
  width: number;
}

export const BRUSH_COLORS = [
  "#1A2023",
  "#FFFFFF",
  "#EA5353",
  "#F7C647",
  "#2196F3",
  "#09B965",
  "#AB59E4",
] as const;

export const BRUSH_DEFAULT_OPTIONS = {
  color: BRUSH_COLORS[0],
  width: 5,
};

class BrushTool extends Tool implements ITool<BrushOptions> {
  private brush: PencilBrush | null = null;

  private isDrawingMode = false;

  private options: BrushOptions = BRUSH_DEFAULT_OPTIONS;

  activate(): void {
    if (!this.canvas) return;

    this.brush = new PencilBrush(this.canvas);

    this.brush.color = this.options.color;

    const width = CanvasUtils.getBrushSize(this.canvas);

    if (width) {
      this.brush.width = width;
      this.options.width = width;
    } else {
      this.brush.width = this.options.width;
    }

    this.canvas.isDrawingMode = true;
    this.canvas.freeDrawingBrush = this.brush;
    this.isDrawingMode = true;

    CanvasUtils.updateCanvasCursor(this.canvas, "crosshair");
  }

  deactivate(): void {
    if (!this.canvas) return;

    this.canvas.isDrawingMode = false;
    this.isDrawingMode = false;
    this.brush = null;

    CanvasUtils.updateCanvasCursor(this.canvas, "default");
  }

  updateOptions({ color, width }: Partial<BrushOptions>): void {
    if (!this.brush || !this.isDrawingMode) return;

    if (color) {
      this.brush.color = color;
      this.options.color = color;
    }

    if (width) {
      this.brush.width = width;
      this.options.width = width;
    }
  }
}

export default BrushTool;
